import styled from "styled-components";
import Colors from "../../../assets/colors/Colors";
import React, {useContext} from "react";
import {YearReportData} from "../../../interfaces/RankingsAndLevelsInterfaces";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import withLoadingAnimation from "../../AnimationWrapper/AnimationWrapper";
import {StyledSkeletonCircle, StyledSkeletonLine} from "../../SkeletonLoader/SkeletonLoaders";

import { useTranslation } from "react-i18next";

const BorderDiv = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border: 3px solid ${Colors.headerNavigationRed};
    width: 75%;
    padding: 19px 28px;
    letter-spacing: 1.3px;
    margin-top: 20px;
    color: ${Colors.headerNavigationRed};

    &:hover {
        color: ${Colors.headerNavigationRed};
        text-decoration: none;
   }

    &.disabled {
        pointer-events: none;
        cursor: default;
    }
`;

const FrontCaret = styled.div`
    margin: auto 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 10px solid ${Colors.headerNavigationRed};
    height: 0px;
    cursor: pointer;
    transform: rotate(90deg);
`;

const ThisYearsGipDownloadComponent: React.FC<{downloadReport: YearReportData}> = ({ downloadReport }) => {
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);
    const { t, i18n } = useTranslation();
    const lng = i18n.language || window.localStorage.i18nextLng || 'es';

    // @ts-ignore
    const downloadURL = downloadReport['download_urls'] && downloadReport['download_urls'][lng] || '#';
    return (
        <BorderDiv href={downloadURL} download target='_blank' rel="noopener noreferrer" className={downloadURL ? '' : 'disabled'}>
            {
                withLoadingAnimation(
                    <React.Fragment>
                        <div style={{fontFamily: 'Mapfre-Black'}}>
                          { t('pdfDownload.reports.report', { year: downloadReport.year + 1 }) }
                        </div>
                        <FrontCaret />
                    </React.Fragment>,
                    <StyledSkeletonLine customStyle={{width: '100%'}}/>,
                    allDataLoaded
                )
            }
        </BorderDiv>
    )
};

export default ThisYearsGipDownloadComponent;
